<template>
  <div>
    <div class="page_404">
      <div v-if="showLottie" class="row">
          <div class="col-12">
          <div class="text-center">
            <h1>404</h1>
            <div class="contant_box_404">
              <p>Hopa, a apărut o eroare</p>
              <p class="mt-3 subText">Din păcate, pagina pe care o cauți nu poate fi afișată. Utilizează linkul de mai jos pentru a găsi mai multe informații.</p>
              <button-component
                text="Către prima pagină"
                :action="{ anchor: true, link: '/' }"
                :addClass="buttonClass"
              />
            </div>
            <lottie-vue-player
              :src="LottieUrl"
              :autoplay="true"
              :backgroundColor="playerBackground"
              style="background: transparent"
              :loop="true">
              </lottie-vue-player>
          </div>
        </div>
      </div>
      <div v-else class="row">
          <div class="col-12">
          <div class="text-center">
            <h1>404</h1>
            <div class="row justify-content-center">
              <div class="col-12 col-md-8">
                <div class="image_block"></div>
              </div>
            </div>
            <div class="contant_box_404">
               <p>nu s-a gasit pagina</p>
              <button-component
                text="Către prima pagină"
                :action="{ anchor: true, link: '/' }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import buttonComponent from "./button-component.vue";

export default {
  name: "error-page",
  components: { buttonComponent },
  props: {
    LottieUrl: {
      type: String,
      default: "/assets/Lottie/error-Lottie-blue-bear-pink-boat.txt"
    },
    buttonClass: {
      type: String,
      default: ""
    },
    showLottie: {
      type: Boolean,
      default: false
    },
    playerBackground: {
      type: String,
      default: "transparent"
    }
  }
};
</script>
<style lang="scss" scoped>
.page_404 {
  padding: 40px 0;
  font-family: "Plus Jakarta Sans";

  h1 {
    font-size: 80px;
    padding: 30px 0 15px;

    @media (max-width: 767px) {
      font-size: 60px;
    }
  }
}

.page_404 img {
  width: 100%;
}

.image_block {
  background-image: url(../../assets/images/gif/error_visual.gif);
  height: 400px;
  width: 100%;
  background-position: center;
  background-size: cover;

  @media (max-width: 767px) {
    height: 320px;
  }
}

.contant_box_404 {
  p {
    font-size: 28px;
    color: #081821;
    padding: 0;

    @media (max-width: 767px) {
      font-size: 22px;
    }
  }
  .subText {
    font-size: 16px;
    line-height: 26px;
    padding: 0;
  }

  button {
    margin-top: 60px;
  }
}

.link_404 {
  color: #fff !important;
  padding: 10px 20px;
  background: #39ac31;
  margin: 20px 0;
  display: inline-block;
}
.text-center {
  h1 {
    font-size: 64px;
    line-height: 64px;
  }
  p {
    font-size: 24px;
    line-height: 30px;
  }
  .subText {
    font-size: 16px;
    line-height: 26px;
  }
}
.vue-lottie-player {
  @media (min-width: 576px) {
    margin-top: -90px;
    z-index: -1;
  }
  @media (min-width: 768px) {
    margin-top: -120px;
  }
  @media (min-width: 992px) {
    margin-top: -150px;
  }
  @media (min-width: 1200px) {
    margin-top: -180px;
  }
}
</style>

